import React from 'react';
import PropTypes from 'prop-types';
import { Profile } from '@one-thd/sui-icons';
import { ProfileImage } from '../ProfileImage/ProfileImage';
import { FavoriteIcon } from '../FavoriteIcon/FavoriteIcon';

/**
 *
 * @param candidate using this to render the img and the toggled/not toggled favoriting icon
 * @returns {JSX.Element}
 */
export const ProfileImageWithFavoriteIcon = ({ candidate }) => {
  return (
    <div className="slm-profile-image-with-favorite-icon__wrapper">
      {candidate.profilePicture ? <ProfileImage profilePicture={candidate.profilePicture} /> : <Profile className="slm-profile-image-with-favorite-icon__default-image" />}
      <div className="slm-profile-image-with-favorite-icon__favorite-icon-wrapper">
        <FavoriteIcon candidate={candidate} />
      </div>
    </div>
  );
};

ProfileImageWithFavoriteIcon.propTypes = {
  candidate: PropTypes.shape({
    profilePicture: PropTypes.string
  })
};

ProfileImageWithFavoriteIcon.defaultProps = {
  candidate: PropTypes.shape({
    profilePicture: ''
  })
};
